import axios from "axios";
import { API_BASE_URL } from "../config/index";

const getFilterArrayFromFilters = (filters: any) => {
  const filterArray = [];
  if (filters.ids && filters.ids.length > 0) {
    filterArray.push({
      property: "id",
      value: filters.ids,
      operator: "in",
    });
  }

  if (filters.language) {
    filterArray.push({
      property: "language",
      value: filters.language,
      operator: "eq",
    });
  }

  if (filters.search) {
    filterArray.push({
      property: "word",
      value: encodeURI(filters.search),
      operator: "like",
    });
  }

  if (filters.author) {
    filterArray.push({
      property: "user.id",
      value: filters.author,
      operator: "in",
      enableAvatar: 1,
    });
  }

  if (filters.isExternal !== null) {
    filterArray.push({
      property: "isExternal",
      value: filters.isExternal,
      operator: "eq",
    });
  }

  return filterArray;
};

export const getArticles = async (filters, token) => {
  try {
    if (!token) {
      console.error("no token provided");
      return { data: [], nbResult: 0 };
    }

    const fields = [
      "*",
      "url",
      "introduction",
      "author",
      "main_media",
      "category",
      "image_reduced",
      "organization",
      "avatars",
      "chains",
      "type",
    ];

    const filterData = [];
    const extractedFilters = getFilterArrayFromFilters(filters);

    filterData.push(...extractedFilters);

    let sort = [];
    if (!filters.ids) {
      sort.push({
        property: "publishedAt",
        dir: "desc",
      });
    }

    const params = {
      access_token: token,
      filter: JSON.stringify(filterData),
      sort: JSON.stringify(sort),
      fields: fields.join(","),
      workspace: "rss",
    };

    const response = await axios.get(`${API_BASE_URL}/blog/article`, {
      params,
    });
    const data = response?.data;

    return { data: data?.data, nbResult: data?.nbResult };
  } catch (e) {
    console.log("Error", e);
    return { data: [], nbResult: 0 };
  }
};

export const getRubrics = async (filters, token) => {
  try {
    if (!token) {
      console.error("no token provided");
      return { data: [], nbResult: 0 };
    }

    const fields = ["*", "children", "chain", "author"];

    const filterData = [];
    const extractedFilters = getFilterArrayFromFilters(filters);

    filterData.push(...extractedFilters);

    let sort = [];
    if (!filters.ids) {
      sort.push({
        property: "publishedAt",
        dir: "desc",
      });
    }

    const params = {
      access_token: token,
      filter: JSON.stringify(filterData),
      sort: JSON.stringify(sort),
      fields: fields.join(","),
      workspace: "rss",
    };

    const response = await axios.get(`${API_BASE_URL}/media/faq-rubric`, {
      params,
    });
    const data = response?.data;

    return { data: data?.data, nbResult: data?.nbResult };
  } catch (e) {
    console.log("Error", e);
    return { data: [], nbResult: 0 };
  }
};
